// extracted by mini-css-extract-plugin
export default {"customerDrop":"CustomerDrop_customerDrop__MjjGr","customerDropCont1":"CustomerDrop_customerDropCont1__wdion","customerMenu":"CustomerDrop_customerMenu__YnN3I"};